import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import zh from "./locales/zh.json";

const i18n = createI18n({
  legacy: true, // 讓 {{ $t() }} 可以使用
  locale: localStorage.getItem("lang") || "zh", // 記住語言
  fallbackLocale: "en",
  messages: {
    en,
    zh,
  },
});

export default i18n;